module.exports = {
      id: "angle-down-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#angle-down",
      toString: function () {
        return this.url;
      }
    }